import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import PersonnesRH from '../components/PersonnesRH.vue';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const app = createApp({
            template: '<PersonnesRH />',
            components: {
                PersonnesRH
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        app.config.globalProperties.personnesRH = personnesRh;
        app.mount(self.el);
    }
}
